// Alertas das datas das fichas (texto 10, A4): o editor fica embaixo do campo de data (ou do horário que vem
// logo depois dele) e a lista escolhida fica em r.c._alertas[campo]. Sem lista: o aviso padrão do campo
// (X dias antes e no dia, às 9h), como era antes. Agendados em notifications/rescheduleAll (identificador m:).
import type { AlertaItem } from '../store/types';
import type { Campo, Colecao } from './tipos';
import { alertasDosDias, opcoesDias, quandoDosAlertas, type QuandoAlerta } from '../lib/alertasData';

/** O campo de horário que acompanha esta data (o 'hora' logo depois dela na ficha), se houver. */
export function horaDoCampo(col: Colecao, f: Campo): Campo | null {
  const i = col.campos.indexOf(f), h = col.campos[i + 1];
  return f.t === 'data' && h?.t === 'hora' ? h : null;
}
/** A data tem alertas? (aviso padrão, horário junto ou alerta: true) */
export const campoComAlerta = (col: Colecao, f: Campo) => f.t === 'data' && (!!f.aviso?.length || !!f.alerta || !!horaDoCampo(col, f));

/** Os alertas da data: os escolhidos na ficha ou o aviso padrão do campo. */
export function alertasDoCampo(c: Record<string, any>, f: Campo): AlertaItem[] {
  const l = c?._alertas?.[f.k];
  return Array.isArray(l) ? l : f.aviso?.length ? alertasDosDias(f.aviso) : [];
}
/** Guarda a lista de alertas da data na ficha. */
export const comAlertas = (c: Record<string, any>, k: string, itens: AlertaItem[]) => ({ ...c, _alertas: { ...(c._alertas ?? {}), [k]: itens } });

/** Opções de "dias antes" do editor para o campo. */
export const diasDoCampo = (f: Campo) => opcoesDias(f.aviso ?? []);

/** Quando os alertas da data tocam (vazio = data vazia ou sem alertas). */
export function quandoDoCampo(col: Colecao, f: Campo, c: Record<string, any>): QuandoAlerta[] {
  const v = c[f.k];
  if (typeof v !== 'string' || !v) return [];
  const h = horaDoCampo(col, f);
  const fz = col.campos.find(x => x.t === 'fuso'), tz = fz && typeof c[fz.k] === 'string' && c[fz.k] ? c[fz.k] : null;
  return quandoDosAlertas(v, h ? c[h.k] : null, alertasDoCampo(c, f), tz);
}
